export default {
  appNameA: 'Sourcing & Manufacturing',
  appNameB: 'End-to-End',
  appShortName: 'SMEE',
  label: {
    account: 'Account',
    add: 'Add',
    createdBy: 'Created By',
    createDate: 'Create Date',
    comment: 'Comment',
    comments: 'Comments',
    delete: 'Delete',
    email: 'Email',
    failed: 'Failed',
    from: 'From',
    mySubscription: 'My Subscription',
    online: 'Online',
    or: 'OR',
    password: 'Password',
    pleaseSelect: 'Please Select',
    range: 'Range',
    reset: 'Reset',
    resolution: 'Resolution',
    resolutionType: 'Resolution Type',
    save: 'Save',
    search: 'Search',
    signIn: 'Sign In',
    singleSignOn: 'Single Sign On',
    status: 'Status',
    submit: 'Submit',
    success: 'Success',
    to: 'To'
  },
  message: {
    loginHints: 'Sign in to start your session'
  },
  menu: {
    wipMst: 'WIP MST',
    create: 'Create'
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js